
import StringUtils from "./string_utils";
import {ApiEndPoint} from "../network/api_end_point";
import {encryptToken} from "./encyption_decryption_algo.js";

const apiEndPoint = new ApiEndPoint();

export function fmOrderTrackingUrlFormation(awb) {
    const storedToken = localStorage.getItem("token");
    const storedUid = localStorage.getItem("uid");

    const idToken = storedToken ? JSON.parse(storedToken) : "";
    const uid = storedUid || "";

    const channelId = localStorage.getItem("channelId") || "";
    const isFromHostApplication =
        localStorage.getItem("isFromHostApplication") || "";

    const orderTrackingPath =apiEndPoint.orderTrackingDetails;
    const baseUrl = `${apiEndPoint.shipping_url}${orderTrackingPath}`;

    const params = new URLSearchParams();

    params.set("awb", awb);

    if (!isFromHostApplication) {
        const encryptedUid = encryptToken(uid, StringUtils.frameKey);
        const encryptedToken = encryptToken(
            idToken,
            StringUtils.frameKey
        );

        params.set("ch", channelId);
        params.set("uid", encryptedUid);
        params.set("t", encryptedToken);
    }

    return `${baseUrl}?${params.toString()}`;
}